import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import { IDamagedPointsItem } from '@/common/components/adjusterReport/damagedPoints/damagedPoints.type';
import { Box, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

const PointsItems = ({ item, removePoint, removeAble }: IDamagedPointsItem) => {
  return (
    <Box
      key={item.id}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      px={12}
      py={8}
      bg="gray-3"
      borderRadius={8}
      w={'100%'}
    >
      <Flex alignItems="center">
        {' '}
        <Typography textStyle="b2" color={!removeAble ? 'black-3' : 'black-1'}>
          {` ${item?.side} - `}
        </Typography>
        <Typography
          mr={2}
          textStyle="b2"
          color={!removeAble ? 'black-3' : 'black-1'}
        >
          {` ${item?.name} `}
        </Typography>
      </Flex>
      {removeAble && (
        <CloseIcon
          stroke={token('colors.black-3')}
          onClick={() => removePoint?.(item)}
        />
      )}
    </Box>
  );
};
export default PointsItems;
